import styled, { css } from 'styled-components';


interface DefaultContainerSummaryProps {
  noPadding?: boolean;
  marginTop?: any;
  position?: any;
  justifyContent?: any;
}

export const DefaultContainer = styled.div`
    display: flex;
`;

export const DefaultContainerSummary = styled.div<DefaultContainerSummaryProps>`
    display: flex;
    margin-top: ${props => props.marginTop}%;
    position: ${props => props.position};
    justify-content: ${props => props.justifyContent};
    ${(props) =>
    props.noPadding ?
      css`
            padding: 0;
        ` : css`
            padding: 0 0 0 16px
        `}
`;

export const PaymentSummaryContainer = styled.div`
    background: #fff;
    width: 30%;
    height: 100vh;
    position: relative;
`;
export const TitleSummary = styled.span`
    font-size: 18px;
    font-weight: 400;
    margin-top: 24px;
`;

export const LinkLabelSummary = styled.span`
    font-size: 14px;
    font-weight: 400;
    color: #F58220;
    text-decoration: underline;
    cursor: pointer;
`;

export const DefaultTextSummary = styled.span<{ weight: number; color: string; }>`
    font-size: 14px;
    font-weight: ${props => props.weight};
    color: ${props => props.color};
`;

export const DefaultTextLinkSummary = styled.a`
    font-weight:400;
    cursor: pointer;
`;

export const CreditPaymentDiv = styled.div`
  display: flex;
  flex-direction: column;
  /* gap: 24px; */
  min-height: fit-content;
  width: 70%;
  margin: 2.7%;
  background-color: #fff;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.14);
  border-radius: 12px;
`;

export const DefaultRowForm = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 0 1.1% 2.2% 1.1%;
`;

export const RowCepForm = styled.div`
    display: flex;
    /* justify-content: space-between; */
    margin: 0 1.1% 2.2% 1.1%;
`;

export const TextCep = styled.a`
    font-size: 12px;
    font-weight: 400;
    text-decoration: underline;
    color: #F58220;
    
    /* position: relative; */
`;

export const DefaultTextModal = styled.span<{ weight: any }>`
    color: rgba(128, 126, 128, 1);
    font-size: 16;
    font-weight: ${props => props.weight};
    text-align: center;
`;

export const CercEPci = styled.div`
    display: flex;
    width: 185px;
    justify-content: space-between;
    margin: 12px auto 0;
    align-items: center;

    > :nth-child(1) {
      width: 60%;
    }

    > :nth-child(2) {
      width: 40%;
    }
`;

export const DivDefaultModal = styled.div`

    position: fixed;
    top: 0;
    left: 0;
    background: #00000065;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;

    p,
    h2 {
      margin: 0;
    }

`;

export const DivModalPrivacyContent = styled.div`

    background: #fff;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12),
      0px 1px 3px rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    padding: 32px 16px;
    max-height: 460px;
    width: 70vw;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    overflow-y: auto;
`;


export const DivModalPrivacyButton = styled.div`

    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 8px;

    button {
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 10px;
      border: none;
      background-color: #f58220;
      color: #fff;
      padding: 10px 20px;
      border-radius: 12px;
      transition: filter 0.2s;

      svg {
        color: #f58220;
        background-color: #fff;
        border-radius: 50%;
      }

      &:hover {
        filter: brightness(0.8);
      }
    }
`;

export const DivModalTermsContent = styled.div`
  * {
    margin: 0;
    padding: 0;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  gap: 16px;

  h2 {
    font-size: 16px;
    line-height: 24px;
    align-self: center;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 8px;

    h3 {
      font-size: 14px;
      line-height: 21px;
      font-weight: 600;
    }

    p {
      font-size: 14px;
      line-height: 21px;
      font-weight: 400;
      text-align: justify;
    }
  }
`;


export const ModalCredit = styled.div`
position: fixed;
    top: 0;
    left: 0;
    background: #00000065;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
  p,
  h2 {
    margin: 0;
  }
  display: flex !important;
`;
export const ModalContent = styled.div`
  background: #fff;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12),
    0px 1px 3px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  padding: 32px 16px;
  max-width: 480px;
  max-height: 460px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  overflow-y: auto;
`;

export const ModalDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;
export const ModalButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 8px;

  button {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    border: none;
    background-color: #f58220;
    color: #fff;
    padding: 14px 20px;
    border-radius: 12px;
    transition: filter 0.2s;

    svg {
      color: #f58220;
      background-color: #fff;
      border-radius: 50%;
    }

    &:hover {
      filter: brightness(0.8);
    }
  }

`;

export const ModalContentTitle = styled.h2`
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    color: #005fae;
`;

export const ModalDetailContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-bottom: 1px solid#4D4C4D;
    padding-bottom: 2px;

    h2 {
      font-size: 12px;
      line-height: 18px;
      font-weight: 600;
      color: #4d4c4d;
    }
`;

export const ModalDetailContainerDebt = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #4d4c4d;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
`





/*
.modalTerms {
  * {
    margin: 0;
    padding: 0;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  gap: 16px;

  h2 {
    font-size: 16px;
    line-height: 24px;
    align-self: center;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 8px;

    h3 {
      font-size: 14px;
      line-height: 21px;
      font-weight: 600;
    }

    p {
      font-size: 14px;
      line-height: 21px;
      font-weight: 400;
      text-align: justify;
    }
  }
}

*/


export const DefaultSVGForm = styled.svg`
    cursor: pointer;
    max-width: 32px;
`;

